import { Injectable } from '@angular/core';
import { CanActivate, Router,ActivatedRouteSnapshot } from '@angular/router';
import { AuthService, UserService, UserModel, CourseService } from '@bt/core';
import { NotifierService } from 'angular-notifier';


@Injectable()
export class UserGuard implements CanActivate {

    private notifier: NotifierService;
    public isSesion:boolean;
    

    constructor(private router: Router,
        private userService: UserService, 
        private authService: AuthService, 
        private notifierService: NotifierService,
        private courseService: CourseService) {
        
      this.notifier = notifierService;
    }
    
    public canActivate(route: ActivatedRouteSnapshot) {
        if(!this.userService.isSession || this.userService.isSession == undefined){
            this.userService.saveSession()
            .then((resp: any) => {
                this.userService.isSession = resp.data;
              })
              .catch((error: any) => {
                this.notifierService.notify('error', error.error.Msgs[0]);
              });
        }
       
        if (this.userService.getRole() == null) {
            const promise = new Promise<boolean>((resolve, reject) => {
                this.courseService.getUser()
			    .then((resp) => {
                    this.userService.currentUser = resp.data;
			    	resolve(this.verifyRole(route.data['roles']));
			    })
			    .catch((error) => {
                    this.authService.logout();
                    this.notifier.notify('error', 'Пожалуйста выполните авторизацию');
                    resolve(false);
                })
            });
            return promise;
        }
        else{
            return this.verify(this.verifyRole(route.data['roles']));
        }
    }

    public verifyRole(rolesStr:string) : boolean{
        if(!rolesStr){
            return false;
        }
        var roles = rolesStr.split(',');
     
        if(roles.indexOf(this.userService.getRole().toString())==-1 ) {
            //this.notifier.notify('error', 'Пожалуйста выполните авторизацию');
            //this.userService.logout();
        }
        else if(this.userService.getRole() == 0) {
            
            if(this.userService.getStatus() == 20) {
               // this.notifier.notify('error', 'Пожалуйста выполните авторизацию');
                //this.userService.logout();
            } 
            else
                return true;
        }
        else {
            return true;
        }
        return false;
    }


    public verify(isRole:boolean): boolean{
        if(isRole){
            return isRole;
        }
        this.notifier.notify('error', 'Пожалуйста выполните авторизацию');
        this.userService.logout();

        return false;
    }

      
}


// WEBPACK FOOTER //
// ./src/app/user.guard.ts